import { ACTIONS_ALIEXPRESS } from '../actions/aliexpress';

export const aliexpress = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_ALIEXPRESS.ADD_PRODUCTS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_ALIEXPRESS.CHANGE_PRODUCT: {
      const { product } = action;
      return { ...state, byId: { ...state.byId, [product.offer_id]: { ...product } } };
    }
    case ACTIONS_ALIEXPRESS.CHANGE_MARKET: {
      const { market } = action;
      return { ...state, market };
    }
    default:
      return state;
  }
};
